import { createBrowserRouter, Navigate } from "react-router-dom";
import App from "../App";
import TermsPage from "../Pages/Terms/TermsPage";
import PrivacyPolicyPage from "../Pages/PrivacyPolicy/PrivacyPolicyPage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "*",
    element: <Navigate to="/" replace />, // fallback para rota inexistente
  },
]);
